export const SITE_PAGES = {
  MAIN: {
    label: 'home',
    path: '/',
  },
  ADMIN_LOG_IN:{
    label: 'log in',
    path: '/',
  },
  VIEW_A_ROOM: {
    label:'view a room',
    path: '/view_a_room'
  },
  VIEW_A_HOST:{
    label: 'view a host',
    path: '/view_a_host',
  },
  VIEW_BLANK_PAGE: {
    label:'view blank page',
    path: '/view_blank_page'
  },
  VIEW_A_CUSTOMER: {
    label:'view a customer',
    path:'/view_a_customer',
  },
  VIEW_COUPON_DETAIL:{
    label: 'view coupon detail',
    path:'/view_coupon_detail',
  },
  VIEW_CITY_LIST:{
    label: 'view city list',
    path:'/view_city_list',
  },
  VIEW_AN_ORDER:{
    label: 'view an order',
    path:'/view_an_order',
  },

  BOOKING_HISTORY:{
    path:'/'
  },
};
